module.exports = __webpack_public_path__ + "static/sayu-db478cb149cf423f3d9490e41b515864.png";